export default {
    path : "officebuilding-item-sea",
    name : "officebuilding-item-sea",
    meta : {
        title : "项目公海"
    },
    component: () => import('@/pages/officebuilding/sea/Index'),
    redirect: {
        name : "officebuilding-item-sea-whole"
    },
    children: [
        {
            path: 'all',
            name: 'officebuilding-item-sea-whole',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'officebuilding-item-sea-recent',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'officebuilding-item-sea-atme',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'officebuilding-item-sea-meat',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'officebuilding-item-sea-reply',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'officebuilding-item-sea-search',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/officebuilding/seaitem/index.js